import React from 'react';
import {Box, Checkbox, FormControlLabel, Typography} from '@mui/material';
import {RenewalQuote} from '../assets/renewal-checkout';
import {FilingFeeSummary} from './filing-fee-summary';
import {recordPageEvent} from '../assets/page-visit';

export const RenewalPaymentSummary = ({quote, certificateFee, certificateOfStatus, disabled, onCertificateChange}: {
    quote: RenewalQuote | null;
    certificateFee?: {output: string} | null;
    certificateOfStatus: boolean;
    disabled: boolean;
    onCertificateChange: (selected: boolean) => void;
}) => {
    const rows = quote ? [
        {label: 'Service fee', amount: quote.baseServiceFeeOutput},
        {label: 'State annual report fee', amount: quote.baseStateFeeOutput},
        ...(quote.lateFee > 0 ? [{label: 'State late fee', amount: quote.lateFeeOutput}] : []),
        ...(quote.certificateFee > 0 ? [{label: 'Certificate of Status', amount: quote.certificateTotalOutput}] : []),
    ] : [];

    return <Box sx={{mt: 3, mb: 3}}>
        <FilingFeeSummary total={quote?.totalOutput ?? null} rows={rows} onExpand={() => recordPageEvent('breakdown')}/>
        {certificateFee && <Box sx={{mt: 1, p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1}}>
            <FormControlLabel sx={{m: 0, alignItems: 'flex-start'}}
                              control={<Checkbox sx={{p: 0, mr: 1.5}} checked={certificateOfStatus} disabled={disabled}
                                                 onChange={event => onCertificateChange(event.target.checked)}/>}
                              label={<>
                                  <Typography>Add Certificate of Status (+{certificateFee.output})</Typography>
                                  <Typography variant="body2" color="text.secondary">Optional. Emailed after the annual report is processed.</Typography>
                              </>}/>
        </Box>}
    </Box>;
};
